import {Injectable, inject} from '@angular/core';
import {LocalStorageService} from "./local-storage.service";
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {
  private localStorageService: LocalStorageService = inject(LocalStorageService);

  public editing: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private deviceID: string | null = null;
  private tabId: string = crypto.randomUUID();

  public constructor() {
    this.setDeviceID(this.getStoredDeviceID());
  }

  public getTabId(): string {
    return this.tabId;
  }

  public setDeviceID(deviceID: string | null): void {
    this.deviceID = deviceID;
  }

  public getDeviceID(): string | null {
    return this.deviceID;
  }

  public getStoredDeviceID(): string | null {
    if (this.localStorageService.getLocalStorage('deviceID')) {
      return this.localStorageService.getLocalStorage('deviceID');
    }

    const deviceID = Math.random().toString(36).slice(2);
    this.localStorageService.setLocalStorage('deviceID', deviceID);
    return deviceID;
  }

  public setEditing(editing: boolean): void {
    this.editing.next(editing);
  }

  public getEditing(): boolean {
    return this.editing.value;
  }
}
